<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- preventiva e corretiva -->
  <section v-if="manutencao != ''" class="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
    <div class="container">
      <div class="row d-flex">
        <div class="col-md-12 about-intro">
          <div class="row d-flex">
            <div class="col-md-6 d-flex align-items-stretch">
              <div class="img d-flex align-items-center align-self-stretch justify-content-center"
                :style="{ backgroundImage: 'url(' + $imgURL + manutencao[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
              </div>
            </div>
            <div class="col-md-6 pl-md-5 py-5">
              <div class="row justify-content-start pb-3 pt-md-5">
                <div class="col-md-12 heading-section ">
                  <span class="subheading">{{ manutencao[0].itiNome }}</span>
                  <h2 class="mb-4">{{ manutencao[0].itiReferencia }}</h2>
                  <p v-html="manutencao[0].itiResumo1"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END preventiva e corretiva -->

  <!-- preventiva -->
  <section v-if="manutencao != ''" class="ftco-section ftco-services"
    style="background-image: url('/images/use_your_illusion.png'); background-repeat: repeat;">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d-flex align-self-stretch ">

          <div class="pb-4 heading-section heading-section-white">
            <p class="mb-4 textoEditor" v-html="manutencao[0].itiResumo2"></p>
          </div>
        </div>

        <!-- quadros -->
        <div v-for="prevent in listaPrevent" :key="prevent.itiId" class="col-md-3 d-flex align-self-stretch ">
          <div class="services" @click="filtraModal(prevent)" style="cursor: pointer;">
            <div class="d-flex justify-content-end">
              <div class="icon d-flex"><span :class="prevent.itiReferencia"></span></div>
            </div>
            <div class="media-body">
              <h3>{{ prevent.itiNome }}</h3>
            </div>
            <div class="btn-custom d-flex align-items-center justify-content-center"><span
                class="fa fa-chevron-right"></span>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
  <!-- END preventiva -->

  <!-- corretiva -->
  <section v-if="manutencao != ''" class="ftco-section"
    style="background-image: url('/images/use_your_illusion_corretiva.png'); background-repeat: repeat;">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d-flex align-self-stretch ">
          <div class="pb-4 heading-section heading-section-white">

            <p class="mb-4 textoEditor" v-html="manutencao[0].itiDescricao1"></p>
          </div>
        </div>

        <div v-for="corrente in listaCorretiva" :key="corrente.itiId" class="col-md-3 d-flex align-self-stretch ">
          <div class="services" @click="filtraModal(corrente)" style="cursor: pointer;">
            <div class="d-flex justify-content-end">
              <div class="icon d-flex"><span :class="corrente.itiReferencia"></span></div>
            </div>
            <div class="media-body">
                <h3 class="heading mb-3">{{ corrente.itiNome }}</h3>
            </div>
            <div class="btn-custom d-flex align-items-center justify-content-center"><span
                class="fa fa-chevron-right"></span></div>
          </div>
        </div>

      </div>
    </div>
  </section>
  <!-- END corretiva -->

  <!-- modal -->
  <div v-if="showModal" class="modal-overlay">
    <div class="modal-content heading-section">
      <h2>{{ tituloModal }}</h2>
      <div style="height: 400px;overflow-y: scroll;">
        <p v-html="textoModal"></p>
      </div>
      <button @click="closeModal">Fechar</button>
    </div>
  </div>
  <!-- END modal -->

  <!-- callAction -->
  <PageCallAction></PageCallAction>
  <!-- END callAction -->
</template>

<script>
import PageCallAction from '@/components/PageCallAction.vue';
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'ManutencaoView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    manutencao: [],
    preventiva: [],
    listaPrevent: [],
    listaCorretiva: [],
    corretiva: [],

    showModal: false,
    tituloModal: "",
    textoModal: "",

  }),

  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    filtraModal(item) {
      this.tituloModal = item.itiNome;
      this.textoModal = item.itiResumo1;
      this.openModal()
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
  },

  created() {
    this.carregaMetas("Manutenção Performance Elevadores","Manutenção - Performance Elevadores ");

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/40/manutencaotopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca manutenção textos
    axios.get('/Process/InsInstitucional/institucional/41/manutencaotextos/0/x')
      .then(response => {
        this.manutencao = response.data;
        //console.log('manutenção texto')
        //console.log(this.manutencao)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca preventiva
    axios.get('/Process/InsInstitucional/institucional/42/listapreventiva/0/x')
      .then(response => {
        this.listaPrevent = response.data;
        console.log('manutenção preventiva')
        console.log(this.listaPrevent)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca corretiva
    axios.get('/Process/InsInstitucional/institucional/43/listacorretiva/0/x')
      .then(response => {
        this.listaCorretiva = response.data;
        //console.log('manutenção corretiva')
        //console.log(this.listaCorretiva)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 50%;
}

@media (max-width:767px) {
  .modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
}
}
</style>